import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const createReportUrl = gql`
  mutation CreateReportUrlMutation($input: CreateReportUrl!) {
    createReportUrl(input: $input)
  }
`;

export const update = gql`
  mutation UpdateChannelMutation(
    $id: Int!
    $description: String
    $name: String
    $urlLink: String
    $type: ChannelType
    $imageUrl: String
    $autoAddUsers: Boolean
  ) {
    updateChannel(
      input: {
        channel: {
          id: $id
          description: $description
          name: $name
          urlLink: $urlLink
          type: $type
          imageUrl: $imageUrl
          autoAddUsers: $autoAddUsers
        }
      }
    ) {
      channel {
        ...ChannelListItem
      }
    }
  }

  ${Fragments.channel.listItem}
`;

export const remove = gql`
  mutation RemoveChannelMutation($id: Int!) {
    deleteChannel(id: $id)
  }
`;

export const createChannelMemberships = gql`
  mutation CreateChannelMembershipsMutation($input: [CreateChannelMembership!]!) {
    createChannelMemberships(input: $input) {
      ...ChannelMembership
    }
  }

  ${Fragments.channel.membership}
`;

export const addUsers = gql`
  mutation AddUsersToChannelMutation(
    $channelSlug: String!
    $userIds: [Int!]!
    $suppressNotifications: Boolean
  ) {
    addUsersToChannels(
      input: {
        userIds: $userIds
        channelSlugs: [$channelSlug]
        suppressNotifications: $suppressNotifications
      }
    ) {
      channels {
        ...ChannelListItem
      }
    }
  }

  ${Fragments.channel.listItem}
`;

export const removeUser = gql`
  mutation RemoveUserFromChannelMutation($channelSlug: String!, $userId: Int!) {
    removeUserFromChannel(input: { channelSlug: $channelSlug, userId: $userId }) {
      channel {
        id
        slug
        users {
          ...ShortUser
        }
      }
    }
  }

  ${Fragments.user.short}
`;

export const snooze = gql`
  mutation SnoozeChannelMutation($id: Int!, $until: DateTime) {
    snoozeChannel(input: { id: $id, until: $until }) {
      channel {
        id
        slug
        snoozeUntil
      }
    }
  }
`;

export const updateNotificationSettings = gql`
  mutation UpdateChannelNotificationSettingsMutation(
    $id: Int!
    $notificationSettings: NotificationType!
  ) {
    updateChannelNotification(
      input: { channelId: $id, notificationSettings: $notificationSettings }
    ) {
      channel {
        id
        slug
        notificationSettings
      }
    }
  }
`;

export const create = gql`
  mutation CreateChannelMutation($input: [CreateChannel!]!) {
    created: createChannelsV2(input: $input) {
      ...ChannelCreate
    }
  }

  ${Fragments.channel.channelCreate}
`;

export const updateChannelV2 = gql`
  mutation UpdateChannelV2Mutation($input: UpdateChannelV2!) {
    updateChannelV2(input: $input) {
      id
      slug
      bundle {
        ...Bundle
      }
    }
  }

  ${Fragments.bundle.bundle}
`;

export const updateMembership = gql`
  mutation UpdateChannelMembershipMutation($input: UpdateChannelMembership!) {
    updateChannelMembership(input: $input) {
      ...ChannelMembership
    }
  }

  ${Fragments.channel.membership}
`;

export const createWorkspaceSection = gql`
  mutation CreateWorkspaceSectionMutation($input: CreateWorkspaceSection!) {
    createWorkspaceSection(input: $input) {
      id
      title
    }
  }
`;

export const removeSharedCardLink = gql`
  mutation DeleteSharedCardLinkMutation($id: UUID!) {
    deleteSharedCardLink(id: $id)
  }
`;

export const createSharedCardLink = gql`
  mutation CreateSharedCardLinkMutation($input: CreateSharedCardLink!) {
    createSharedCardLink(input: $input) {
      ...SharedCardLink
    }
  }

  ${Fragments.channel.sharedCardLink}
`;

export const updateWorkspaceSection = gql`
  mutation UpdateWorkspaceSectionMutation($input: UpdateWorkspaceSection!) {
    updateWorkspaceSection(input: $input) {
      ...WorkspaceSection
    }
  }

  ${Fragments.channel.workspaceSection}
`;

export const duplicateWorkspaceSection = gql`
  mutation DuplicateWorkspaceSectionMutation($input: DuplicateWorkspaceSection!) {
    duplicateWorkspaceSection(input: $input) {
      type
      workspaceSection {
        channelAssociations {
          channelId
        }
      }
    }
  }
`;

export const duplicateWorkspace = gql`
  mutation DuplicateWorkspaceMutation($input: DuplicateWorkspace!) {
    duplicateWorkspace(input: $input) {
      type
      workspace {
        id
        slug
      }
    }
  }
`;

export const restoreChannel = gql`
  mutation RestoreChannelMutation($id: Int!) {
    restoreChannel(id: $id) {
      ...DeletedChannel
    }
  }

  ${Fragments.channel.deletedChannel}
`;
